import {
  Component,
  HostBinding,
  inject,
  OnDestroy,
  OnInit,
  signal,
  WritableSignal,
} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {ComuniService} from "src/app/services/comuni.service";
import {UserService} from "src/app/services/user.service";
import {AreeCompetenzaService} from "src/app/services/areeCompetenza.service";
import {TipiInterventoService} from "src/app/services/tipiIntervento.service";
import {TipiSegnalazioneService} from "src/app/services/tipiSegnalazione.service";
import {onSnapshot, Timestamp, Unsubscribe} from "firebase/firestore";
import {Intervento_Firestore} from "src/app/models/firestore/interventoFirestore.model";
import {Intervento} from "src/app/models/intervento.model";
import {TipoIntervento} from "src/app/models/tipoIntervento.model";
import {InterventiService} from "src/app/services/interventi.service";
import {ComuneDTO} from "../../../models/comune.model";
import {PosizioneSegnalazione} from "../../../models/posizione-segnalazione";
import {Sostegno} from "../../../models/sostegno.models";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {environment} from "../../../../environments/environment";
import {Segnalazione_Firestore} from "../../../models/firestore/segnalazioneFirestore.model";
import { SegnalazioniService } from "src/app/services/segnalazioni.service";

@Component({
  selector: "dettagli-intervento",
  templateUrl: './dettagli-intervento.component.html',
  styleUrls: ['../interventi.component.css']
})
export class DettagliInterventoComponent implements OnInit, OnDestroy {

  private readonly segnalazioneSrv = inject(SegnalazioniService);

  intervento!: Intervento;
  interventoFS!: Intervento_Firestore;

  protected tipiIntervento: TipoIntervento[] = [];
  protected modificaInterventoForm: FormGroup;
  private collection_segnalazioni:string = environment.firebase.collection_segnalazioni;

  public isTecnico;

  public comune: ComuneDTO;
  public mapReady: boolean;
  public hasUpdatedPosition: boolean;
  public mapPosition: WritableSignal<PosizioneSegnalazione> = signal({
    indirizzo: null,
    coordinates: null,
    sostegni: [],
    edifici: []
  });
  public sostegniPosition: Sostegno[];

  private firestoreUnsub: Unsubscribe;

  @HostBinding("class.mobile") isMobile: boolean;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _formBuilder: FormBuilder,
    public dialogService: DialogService,
    private comuniService: ComuniService,
    protected userService: UserService,
    protected areeCompetenzaService: AreeCompetenzaService,
    protected tipiSegnalazioneService: TipiSegnalazioneService,
    protected tipiInterventoService: TipiInterventoService,
    private interventiService: InterventiService,
    public firestore: AngularFirestore,
  ) {
    this.detectDevice();

    this.isTecnico = this.userService.getUser().ruolo.codice == "TECNICO";
    // this.logger.info("**NG INIT @ DETTAGLI INTERVENTO");
    // console.log(this.config.data);
    this.intervento = this.config.data.intervento;
    this.interventoFS = this.config.data.interventoFS;

    this.prepareData();
  }

  ngOnInit(): void {
    this.modificaInterventoForm = this._formBuilder.group({
      intervento: new FormControl({value: this.intervento, disabled: false}, Validators.required),
      tipoIntervento: new FormControl({value: null, disabled: true}, Validators.required),
      note: [this.intervento.note],
    });

    if (this.isTecnico) {
      this.modificaInterventoForm.get("note").disable();
    }

    this.loadTipiIntervento();
  }

  ngOnDestroy() {
    if (this.firestoreUnsub) {
      this.firestoreUnsub();
    }
  }

  prepareData() {
    // console.log("intervento ", this.interventoFS, this.intervento);
      const collectionRef = this.firestore.collection(this.collection_segnalazioni).ref;
      const query = collectionRef.where("codice", "==", this.interventoFS.codiceSegnalazione);
      this.firestoreUnsub = onSnapshot(query, (qs) => {

          const segnalazione: Segnalazione_Firestore = qs.empty ? null : qs.docs[0].data() as Segnalazione_Firestore;
          
          this.mapPosition.set({
            indirizzo: segnalazione.indirizzo ?? null,
            coordinates: segnalazione.coordinate && !segnalazione.isCoordinateCalculated ? {
              longitudine: segnalazione.coordinate.longitude,
              latitudine: segnalazione.coordinate.latitude
            } : null,
            sostegni: [],
            edifici: []
          });

          this.segnalazioneSrv.getByID(`${this.intervento.idSegnalazione}`)
          .subscribe((segnalazione) => {
            this.sostegniPosition = segnalazione.sostegni ?? [];
            const edifici = segnalazione.edifici ?? [];
            this.mapPosition.update((current) => {
              return {
                ...current,
                sostegni: [...this.sostegniPosition],
                edifici: [...edifici]
              }
            });
          });


          this.comuniService.get().subscribe((data: ComuneDTO[]) => {
            // console.log("comune segnalazione", this.segnalazione.codiceISTATComune);
            // console.log("comuni", data);
            this.comune = data.find((comune) => {
              return comune.codiceIstat == segnalazione.codiceISTATComune;
            });
            this.mapReady = true;
          });
      });

/*    this.segnalazioniService.getByID(`${this.intervento.idSegnalazione}`).subscribe((segnalazioneApi) => {

      console.log("segnalazione da API ", segnalazioneApi);
      this.sostegniPosition = segnalazioneApi["sostegni"] ?? [];
      this.mapPosition = {
        indirizzo: segnalazioneApi.indirizzo ?? null,
        coordinates: {
          longitudine: segnalazioneApi.coordinate.longitudine,
          latitudine: segnalazioneApi.coordinate.latitudine
        },
        sostegni: [...this.sostegniPosition]
      };


      // this.dataReady = true;

      console.log("posizione segnalazione for dialog map: ", this.mapPosition);

      this.comuniService.get().subscribe((data: ComuneDTO[]) => {
        // console.log("comune segnalazione", this.segnalazione.codiceISTATComune);
        // console.log("comuni", data);
        this.comune = data.find((comune) => {
          return comune.codiceIstat == this.intervento.segnalazione.comune.codiceIstat;
        });
        this.mapReady = true;
      });

    })*/
  }

  detectDevice() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    this.isMobile = isMobile;
  }

  loadTipiIntervento() {
    this.tipiInterventoService.getByIDAreaCompetenza(Number(this.intervento.tipo.areaCompetenza.id)).subscribe(tipiInterventoFromDB => {
      this.tipiIntervento = tipiInterventoFromDB;
      this.modificaInterventoForm.get('tipoIntervento').setValue(this.intervento.tipo);
      ;
      this.modificaInterventoForm.get('tipoIntervento')?.enable();
    });
  }

  isPlannedOnSingleDate(): boolean {
    if (this.formattaTimestamp(this.interventoFS.inizioPianificazione) === this.formattaTimestamp(this.interventoFS.finePianificazione)) {
      return true;
    }
    return false;

  }

  formattaTimestamp(data: Timestamp) {
    if (data != null) {
      const date = data.toDate();
      const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`; // Ad esempio, formato DD/MM/YYYY
      return formattedDate;
    }
    return "";

  }

  formattaData(data: string | Date): string {

    let date: Date;

    if (typeof data === 'string') {
      const cleanData = data.replace(/\[UTC\]$/, '');
      date = new Date(cleanData); // Converti la stringa in oggetto Date
    } else {
      return "";
    }

    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      const formattedDate = `${day}/${month}/${year}`;

      return formattedDate;
    }

    return "";
  }


  chiudi() {
    this.dialogRef.close({
      success: true
    });
  }

  salva() {
    let interventoDaModificare = new Intervento();
    interventoDaModificare.id = this.intervento.id;
    interventoDaModificare.note = this.modificaInterventoForm.get("note").value;
    interventoDaModificare.autore = this.userService.getUser();
    interventoDaModificare.tipo = this.modificaInterventoForm.get('tipoIntervento').value;

    // this.logger.info(interventoDaModificare);
    this.interventiService.modifica(interventoDaModificare).subscribe(interventoModificato => {
      this.dialogRef.close({
        success: true
      });
    })
  }

}
